import { render } from "./ImportExportModal.vue?vue&type=template&id=a1131766&scoped=true"
import script from "./ImportExportModal.vue?vue&type=script&lang=js"
export * from "./ImportExportModal.vue?vue&type=script&lang=js"

import "./ImportExportModal.vue?vue&type=style&index=0&id=a1131766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1131766"]])

export default __exports__